import React from 'react';
import '../../css/Overlay.css';
import CancelIcon from '@material-ui/icons/Close';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import SkipNextIcon from '@material-ui/icons/NavigateNext';
import SkipPreviousIcon from '@material-ui/icons/NavigateBefore';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { isIOS } from 'react-device-detect';
import LanguageSelector from './LanguageSelector';

export default function Overlay({ go, openCart, openThumbnails, cartOpened, overviewOpened, onClose, enterFullScreen, cart, customer, arrowsOnly = false }) {
	const items = cart.reduce((total, line) => total + line.quantity, 0);

	return <div className='catalog_arrow_overlay' style={{ pointerEvents: cartOpened ? 'all' : 'none' }}>
		{overviewOpened && <div className='catalog_arrow_overlay_overview'>
			<div className='catalog_arrow_overlay_top_right' onClick={onClose}><CancelIcon /></div>
		</div>}
		{!overviewOpened && <div className='catalog_arrow_overlay_arrows' >
			<div className='catalog_arrow_overlay_left' onClick={() => go(false)}><SkipPreviousIcon fontSize='large' /></div>
			{!arrowsOnly && <div className='catalog_arrow_overlay_top'>
				<div className='catalog_arrow_overlay_top_left' onClick={openThumbnails}><MenuOpenIcon fontSize='large' /></div>
				{
					!isIOS && <div className='catalog_arrow_overlay_top_middle' onClick={enterFullScreen}><FullscreenIcon fontSize='large' /></div>
				}
				{items > 0 && <div className='catalog_arrow_overlay_top_right' onClick={openCart}>
					<div className='cart-amount-badge'>{items}</div><ShoppingCartIcon fontSize='large' />
				</div>}
				<LanguageSelector style={{pointerEvents:'auto'}} />
				<div className='catalog_arrow_overlay_name'><div>{customer}</div></div>
			</div>}
			<div className='catalog_arrow_overlay_right' onClick={() => go(true)}><SkipNextIcon fontSize='large' /></div>
		</div>}
	</div>;
}
